export const standardFilterFieldSx = {
  mb: 1,
  '& .MuiInputBase-root': {
    padding: 0,
    minHeight: 'auto',
    height: 'auto',
    borderRadius: 0,
    backgroundColor: 'transparent',
    '&::before': {
      display: 'block',
      content: '"\\00a0"',
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
      left: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      pointerEvents: 'none',
      transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '&::after': {
      display: 'block',
      content: '""',
      borderBottom: '2px solid',
      borderColor: 'primary.main',
      left: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      pointerEvents: 'none',
      transform: 'scaleX(0)',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    },
    '&.Mui-focused::after': { transform: 'scaleX(1)' },
    '&:hover:not(.Mui-disabled, .Mui-error)::before': {
      borderBottom: '2px solid',
      borderBottomColor: 'text.primary',
    },
    '&.Mui-error::before, &.Mui-error::after': {
      borderBottomColor: 'error.main',
    },
    '& input.MuiInputBase-input': {
      padding: '4px 0 5px',
    },
  },
}

export const outlinedFilterFieldSx = {
  mb: 1,
  '& .MuiInputBase-root': {
    padding: 0,
    minHeight: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
    borderRadius: 1,
    '&::before, &::after': { display: 'none' },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '&:hover:not(.Mui-disabled, .Mui-error) .MuiOutlinedInput-notchedOutline': {
      borderColor: 'text.primary',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'primary.main',
      borderWidth: 2,
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'error.main',
    },
    '& input.MuiInputBase-input': {
      padding: '10.5px 14px',
    },
  },
}
